import { Suspense, lazy, useEffect, useState } from 'react';

const Banner = lazy(() =>
  import(/* webpackChunkName: "generation-banner" */ './GenerationStatusBanner.jsx')
);

/**
 * Thin host that defers loading the MUI-heavy GenerationStatusBanner until a
 * generation job actually exists. The banner pulls @mui/material + icons (~50
 * KB gzipped); for the 99%+ of sessions with no active job, that bundle never
 * loads. A job is "active" if `activeGenerationJobId` is in localStorage on
 * mount, or if the `generation-job-background` event fires later in the
 * session.
 *
 * Imports nothing from @mui/* directly so this file can stay eager-imported
 * in App.jsx without leaking MUI into the entry chunk.
 */
function GenerationStatusBannerHost() {
  const [hasJob, setHasJob] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('activeGenerationJobId')) {
      setHasJob(true);
    }

    const onJobStart = () => setHasJob(true);
    window.addEventListener('generation-job-background', onJobStart);

    const onStorage = (e) => {
      if (e.key === 'activeGenerationJobId' && e.newValue) {
        setHasJob(true);
      }
    };
    window.addEventListener('storage', onStorage);

    return () => {
      window.removeEventListener('generation-job-background', onJobStart);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  if (!hasJob) return null;

  return (
    <Suspense fallback={null}>
      <Banner />
    </Suspense>
  );
}

export default GenerationStatusBannerHost;
